import IconButton from "components/atoms/button/IconButton";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import Form from "components/atoms/form/Form";
import Icon from "components/atoms/icon/Icon";
import Input from "components/atoms/input/Input";
import Label from "components/atoms/input/input-label/InputLabel";
import TextArea from "components/atoms/text-area/TextArea";
import PrimaryDatePicker from "components/molecules/datepicker/PrimaryDatePicker";
import InputsFolder from "components/molecules/inputs-folder/InputsFolder";
import { IconType } from "lib/helpers/constants/iconTypes";
import {
  Dispatch,
  FC,
  Fragment,
  ReactInstance,
  RefObject,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Controller, useForm } from "react-hook-form";
import ActivityLogItem from "components/molecules/activity-log-item/ActivityLogItem";
import { useCustomerForm } from "lib/hooks/forms/useCustomerForm";
import withModal from "lib/helpers/hoc/withModal";
import { useUpdateCustomer } from "lib/hooks/mutations/Customers/useUpdateCustomer";
import Checkbox from "components/atoms/checkbox/Checkbox";
import { useCreateNewProduct } from "lib/hooks/mutations/Customers/useCreateNewProduct";
import { useCustomerProduct } from "lib/hooks/queries/Coustomer/useCustomerProduct";
import UpdateChooseProducts from "./update-choose-products/UpdateChooseProducts";
import UpdateCustomerDocuments from "./update-customer-documents/UpdateCustomerDocuments";
import { useCustomerDocument } from "lib/hooks/queries/Coustomer/useCustomerDocument";
import Button from "components/atoms/button/Button";
import { useStoreNewCustomerDocument } from "lib/hooks/mutations/Customers/useStoreNewCustomerDocument";
import ErrorState from "components/atoms/error-state/ErrorState";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";
import { useReactToPrint } from "react-to-print";
import { useRefetchPartnersForFilter } from "lib/hooks/queries/Partners/useRefetchPartnersForFilter";
import { useCustomerLogs } from "lib/hooks/queries/Coustomer/useCustomersLogs";
import { EmailIcon, PhoneIcon } from "components/atoms/icon/export";
import SendEmailAppointment from "components/organisms/appointment-management/update-appointment/update-appointment-step/SendEmailAppointment";
import CallAppointment from "components/organisms/appointment-management/update-appointment/update-appointment-step/CallAppointment";
import { useCustomerFamilyMembers } from "lib/hooks/queries/Coustomer/useCustomerFamilyMembers";
import UpdateRelatedCustomerForm from "./update-related-customer-form/UpdateRelatedCustomerForm";
import Tooltip from "components/molecules/tooltip/Tooltip";
import { useHover } from "lib/hooks/shared/useHover";
import { languageData } from "lib/helpers/constants/languageData";
import { customStyles } from "lib/helpers/configs/customStyles";
import Creatable from "react-select/creatable";
import { options } from "lib/helpers/constants/optionsOfCustomers";
import { useTranslation } from "react-i18next";
import { usePermissions } from "lib/hooks/shared/usePermissions";
import { useCustomerSource } from "lib/hooks/queries/Coustomer/useCustomerSource";
import { usePartnerSingleProduct } from "lib/hooks/queries/Partners/usePartnerSingleProduct";
import ViewQualityCheck from "./view-quality-check/ViewQualityCheck";
import CreateFollowUpTask from "./create-follow-up-task/CreateFollowUpTask";
import { nationalities } from "lib/helpers/constants/nationalities";
import { StatusBackground } from "lib/hooks/shared/getStatusColorCustomer";
import SubmitFiles from "./submit-files/SubmitFiles";
import ViewPendingFile from "./view-pending-file/ViewPendingFile";
import AutoCompletInput from "components/atoms/input/autocomplet-input/AutoCompletInput";
import { useRegions } from "lib/hooks/queries/User/useRegions";
import { getUsersByPermission } from "api/User";
import AddNewField from "../create-customer/add-new-field/AddNewField";
import CounterControl from "components/molecules/counter-control-append/CounterControlAppend";

interface ActivityLogData<T> {
  data: T;
}

interface IUpdateCustomerProcessPrpos<T> {
  onConfirm: () => void;
  setIsModalOpen: any;
  setCurrentFormStep: Dispatch<number>;
  currentStep: number;
  data: T;
  themeColors: {
    primary: string;
  };
}

const UpdateCustomerProcess: FC<IUpdateCustomerProcessPrpos<any>> = ({
  currentStep,
  onConfirm,
  setCurrentFormStep,
  data,
  setIsModalOpen,
  themeColors,
}) => {
  const [activeTab, setActiveTab] = useState<number>(1);
  const [fileSize, setFileSize] = useState("");
  const [fetchedUsers, setFetchedUsers] = useState<Array<string>>([]);
  const { mutate: updateCustomer, isLoading: updateLoading } =
    useUpdateCustomer();
  const { mutateAsync: storeNewProduct, isLoading: isLoadingStoredProduct } =
    useCreateNewProduct();
  const { data: familyMemberData, isError } = useCustomerFamilyMembers({
    costumer_id: data.id,
  });
  const {
    data: customerDocumentsData,
    refetch: refetchDocuments,
    isLoading: isLoadingGettingDocuments,
  } = useCustomerDocument(
    {
      costumer_id: data.id,
    },
    {
      enabled: currentStep === 3 ? true : false,
    }
  );

  const {
    data: activityLogData,
    refetch: refetchLogs,
    isLoading: isLoadingLogs,
  } = useCustomerLogs(
    {
      costumer_id: data.id,
    },
    {
      enabled: activeTab === 4 ? true : false,
    }
  );
  const {
    mutateAsync: storeDocument,
    isLoading: isStoringLoadingDocument,
    isError: hasErrorOnDocument,
  } = useStoreNewCustomerDocument();

  const {
    data: customerProducts,
    isLoading: isLoadingCustomerProducts,
    refetch: refetchProducts,
  } = useCustomerProduct(
    {
      costumer_id: data.id,
    },
    {
      enabled: activeTab === 2 ? true : false,
    }
  );

  useEffect(() => {
    getUsersByPermission({
      permissions: ['customers_view_view', 'customers_view_view_own'],
    })
      .then((res) => {
        setFetchedUsers(res.users);
      })
      .catch(() => { });
    // eslint-disable-next-line
  }, []);

  const hasPermissionToAssignCustomers = usePermissions(['assign_customers_assign']);

  const { handleSubmit: handleSubmitExtraField } = useForm();

  const { data: partnersData, refetch: refetchPartners } =
    useRefetchPartnersForFilter();

  const token: any = localStorage.getItem("token");
  const [formDataOfProducts, setFormDataOfProducts] = useState<any>({});
  const [fileLink, setFileLink] = useState<string>();
  const [uploadedFileUrl, setUploadedFileUrl] = useState<string | null>(null);
  const [viewFileUrl, setViewFileUrl] = useState<string | null>(null);
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();
  const [hasDocumentName, setHasDoucmentName] = useState<string | undefined>();

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
    clearErrors
  } = useCustomerForm({
    defaultValues: {
      ...data,
      extra_fields: data.extra_fields,
    },
  });

  const {
    register: registerUpload,
    handleSubmit: handleSubmitUpload,
    reset: resetUpload,
    watch: watchUpload,
    control: controlUpload,
    formState: { errors: uploadErrors },
  } = useForm();

  const onSubmit = (formData: any) => {
    const necessaryFields = [
      "first_name",
      "last_name",
      "nationality",
      "birthdate",
      "phone",
      "address",
      "city",
      "nationality",
      "date",
      "postal_code",
      "email",
      "nr",
      "note",
      "language",
      "from_user_id",
      "is_type_company",
      "company_name",
      "legal_form",
      "uid_number",
      "company_phone_number",
      "industry",
      "number_of_employees",
      "website",
      "company_email",
      "company_phone_number",
      "prefered_language",
      "salutation",
      "job_title",

    ];

    let extraFields: { [key: string]: any } = {};

    const allExtraFields = [...state, ...formData.extra_fields];




    allExtraFields.forEach((item: any) => {
      extraFields[item?.field_name || item?.data?.field_name] = {
        value: formData[item?.field_name || item?.data?.field_name],
        default_text: item?.default_text || item?.data?.default_text,
        required: item?.required || item?.data?.required ? 1 : 0,
        section: item?.section || item?.data?.section,
        field_type: item?.field_type || item?.data?.field_type,
      };
      delete formData[item?.field_name || item?.data?.field_name];
    });

    const extraFieldsArray = Object.keys(extraFields).map((key) => ({
      section: extraFields[key].section,
      field_name: key,
      field_value: extraFields[key].value,
      default_text: extraFields[key].default_text,
      required: extraFields[key].required,
      field_type: extraFields[key].field_type,
    }));

    const { id, ...restFormData } = formData;
    const updateFilter = Object.keys(restFormData).reduce(
      (acc: { [key: string]: any }, key) => {
        if (necessaryFields.includes(key)) {
          acc[key] = restFormData[key];
        }
        return acc;
      },
      { extra_fields: extraFieldsArray, costumer_id: id }
    );
    updateCustomer(updateFilter);
    onConfirm();
  };

  const handleCheckboxChange = (checkboxValue: string, checked: boolean) => {
    setFormDataOfProducts((prevFormData: any) => ({
      ...prevFormData,
      [checkboxValue]: {
        checked: checked,
        selected: checked ? prevFormData[checkboxValue]?.selected || "" : "",
      },
    }));
  };

  const { t } = useTranslation();

  const handleSelectChange = (checkboxValue: string, selected: string) => {
    setFormDataOfProducts((prevFormData: any) => ({
      ...prevFormData,
      [checkboxValue]: {
        ...prevFormData[checkboxValue],
        selected: selected,
      },
    }));
  };

  const handleProductChange = (checkboxValue: string, selected: string | null) => {
    setFormDataOfProducts((prevFormData: any) => ({
      ...prevFormData,
      [checkboxValue]: {
        ...prevFormData[checkboxValue],
        product_name: selected,
      },
    }));

  };




  const defaultOptions = [
    {
      id: 0,
      checkboxValue: 'KVG',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 1,
      checkboxValue: 'VVG',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 2,
      checkboxValue: 'Life',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 3,
      checkboxValue: 'Lawprotection',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 4,
      checkboxValue: 'Business',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 5,
      checkboxValue: 'Auto',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),

    },
    {
      id: 6,
      checkboxValue: 'Company',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),

    },
  ]

  const [optionsByCheckbox, setOptionsByCheckbox] = useState<any>(defaultOptions);

  useLayoutEffect(() => {
    if (partnersData) {

      setOptionsByCheckbox(defaultOptions);
    }

    //eslint-disable-next-line
  }, [partnersData]);



  const [PartnerParams, setPartnerParams] = useState<any>({ base_product: null, partner_id: null });

  const { data: partnerProductsData, isLoading } = usePartnerSingleProduct(PartnerParams);

  const [PartnerProductsState, setPartnerProductsState] = useState<Record<string, any>>({});


  useEffect(() => {
    if (partnerProductsData && PartnerParams.base_product) {
      setPartnerProductsState((prev) => ({
        ...prev,
        [PartnerParams.base_product]: partnerProductsData
      }));
    }
  }, [partnerProductsData, PartnerParams.base_product]);

  const [LastChangedSelectId, setLastChangedSelectId] = useState(null);

  useEffect(() => {
    if (PartnerParams.base_product) {
      setValue(`product.${LastChangedSelectId}`, null);

    }
    if (LastChangedSelectId) {
      handleProductChange(LastChangedSelectId, null);
    }
    // eslint-disable-next-line
  }, [partnerProductsData]);

  const addNewOption = (checkboxValue: string) => {
    setOptionsByCheckbox((prevOptions: any) => {
      // Find the index of the option that matches the checkboxValue
      const index = prevOptions.findIndex((option: any) => option.checkboxValue === checkboxValue);

      if (index !== -1) {
        // Create the new option with an updated ID and custom options
        const newOption = {
          ...prevOptions[index],
          id: prevOptions.length, // Assign a new unique ID
          customOptions: prevOptions[index].customOptions || [], // Ensure it's an array
        };

        // Insert the new option directly after the found option
        const updatedOptions = [
          ...prevOptions.slice(0, index + 1), // Keep everything before the matched option
          newOption, // Add the new option
          ...prevOptions.slice(index + 1), // Keep everything after the matched option
        ];

        return updatedOptions;
      }

      // If the checkboxValue isn't found, return the original options without changes
      return prevOptions;
    });
  };


  const removeOption = (id: number) => {
    setOptionsByCheckbox((prevOptions: any) => {
      // Filter out the option with the matching ID
      const updatedOptions = prevOptions.filter((option: any) => option.id !== id);


      return updatedOptions;
    });

    setFormDataOfProducts((prevFormData: any) => {
      const updatedFormData = { ...prevFormData };

      delete updatedFormData[id];

      return updatedFormData;
    })
  }

  const onSubmitExtraFields = () => {
    const selectedProducts = Object.keys(formDataOfProducts)
      .filter((key) => formDataOfProducts[key].checked)
      .map((key) => ({
        name_of_product: optionsByCheckbox.filter((option: any) => option.id === parseInt(key))[0].checkboxValue,
        company_of_product: formDataOfProducts[key].selected,
        product_name: formDataOfProducts[key].product_name,
      }));

    const updatedFormData = {
      costumer_id: data.id,
      products: selectedProducts,
    };

    storeNewProduct(updatedFormData)
      .then(() => {

        setFormDataOfProducts({});
        for (let i = 0; i < optionsByCheckbox.length; i++) {
          setValue(`product.${i}`, null);
        }
        setOptionsByCheckbox(defaultOptions)
        setCurrentFormStep(1);

      })
  };

  const [uploadedFile, setUploadedFile] = useState("");
  const [fileName, setFileName] = useState<any>("");

  const onSubmitUploadDocument = (formData: Record<string, any>) => {

    const newFormData = new FormData();

    newFormData.append("document", uploadedFile);
    newFormData.append("costumer_id", data.id);

    for (let key in formData) {
      newFormData.append(key, formData[key]);
    }

    storeDocument(newFormData)
      .then(() => {
        setCurrentFormStep(1);
        setFileName("");
        setUploadedFile("");
        resetUpload();
        setFileSize("");
        refetchDocuments();
      })
      .catch(() => { });
  };

  const handleUploadClick = (): void => {
    const formData = {
      file_section: watchUpload("file_section"),
      file_name: watchUpload("file_name"),
    } as any;
    const newFormData = new FormData();
    newFormData.append("document", uploadedFile);
    newFormData.append("costumer_id", data.id);
    for (let key in formData) {
      if (formData.hasOwnProperty(key)) {
        newFormData.append(key, formData[key]);
      }
    }
    storeDocument(newFormData).then(() => {
      setCurrentFormStep(1);
      setFileName("");
      setUploadedFile("");
      resetUpload();
      setFileSize("");
      refetchDocuments();
    });
  };

  const componentRef = useRef<ReactInstance | null>(null);
  const hasPermissiontoViewProducts = usePermissions(['manage_customers_products_view']);
  const hasPermissiontoViewDocuments = usePermissions(['customers_documents_view']);
  const hasPermissiontoViewActivitylog = usePermissions(['customers_activitylog_view']);
  const hasPermissionToViewRelationship = usePermissions(['manage_customers_relationship_view']);
  const hasPermissionToEditRelationship = usePermissions(['manage_customers_relationship_edit']);
  const hasPermissionToViewQuality = usePermissions(['manage_customers_quality_view']);
  const hasPermissionToEditCostumer = usePermissions(['customers_view_edit']);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [relatedCustomers, setRelatedCustomers] = useState<any[]>([]);

  const handleAddCustomer = (customer: any) => {
    setRelatedCustomers([
      { id: customer.id, name: `${customer.first_name} ${customer.last_name}` },
    ]);
  };

  const { data: customerSourceData, isLoading: isLoadingCustomerSource } = useCustomerSource({ costumer_id: data.id });

  const [IsTaskModalOpen, setIsTaskModalOpen] = useState(false)


  let extraFields: { [key: string]: any } = {};
  const [state, setState] = useState<any>([]);

  const statusCounts = useMemo(() => {

    let products

    if (customerProducts === undefined) {
      products = data.products
    }
    else {
      products = (customerProducts as any).data
    }

    const productsToReduce = products

    const counts: { [key: string]: number } = {};

    for (const item of productsToReduce) {
      const status = item.status;
      if (status in counts) {
        counts[status]++;
      } else {
        counts[status] = 1;
      }
    }

    return counts

  }, [data, customerProducts])

  const getProductsLength = useMemo(() => {

    let products

    if (customerProducts === undefined) {
      products = data.products
    }
    else {
      products = (customerProducts as any).data
    }

    return products.length

  }, [data, customerProducts])


  const [DocumentData, setDocumentData] = useState()

  const [CheckedDocuments, setCheckedDocuments] = useState([])


  const { data: regionsData } = useRegions()

  const flatData = useMemo(() => {

    if (!regionsData) return []

    return (regionsData as any)?.data.map((item: { plz: any; ort: any; commune: any; }) => `${item.plz}, ${item.ort}, ${item.commune ?? ''}`);

  }, [regionsData])


  const [LocationValue, setLocationValue] = useState('');


  useEffect(() => {

    if (LocationValue !== '') {

      const SplitLocation = LocationValue?.split(',')

      setValue("postal_code", SplitLocation[0]?.trim());

      if (SplitLocation[1]?.trim()) {
        setValue("city", SplitLocation[1]?.trim() + (SplitLocation[2] ? `,${SplitLocation[2]}` : ''));
      }
    }

  }, [LocationValue, setValue])

  const combinedFields = [
    ...(data?.extra_fields || []),
    ...state.map((item: any) => item.data),
  ];


  const groupedFields: { [section: string]: any[] } = {};

  combinedFields.forEach((field) => {
    extraFields[field.field_name] = {
      value: watch(field.field_name),
      default_text: field.default_text,
    };

    if (!groupedFields[field.section]) {
      groupedFields[field.section] = [];
    }
    groupedFields[field.section].push(field);
  });

  const [IsAddNewFieldModalOpen, setIsAddNewFieldModalOpen] = useState(false)

  console.log(data);

  const isCompany = useMemo(() => {
    return data.is_type_company
  }, [data.is_type_company])

  return (
    <div>
      <ConditionalRender condition={currentStep === 1}>
        <div className="xl:absolute top-[26px] pb-14 xl:pb-0 flex flex-col xl:flex-row items-start gap-3 font-inter-semibold text-[#282D46] text-[22px]">
          {data.first_name + " " + data.last_name}

          <ConditionalRender condition={!isLoadingCustomerSource}>

            <div className="bg-[#7D85921A] text-[#7D8592] w-auto rounded-[8px] font-inter-light px-2 py-1 outline-none text-[14px] md:text-[16px]">
              {t('Source')} : {t(customerSourceData?.source) || 'Unknown'}, {t(customerSourceData?.sourceName) || 'Unknown'}
            </div>

            <div className="bg-[#7D85921A] text-[#7D8592] w-auto rounded-[8px] font-inter-light px-2 py-1 outline-none text-[14px] md:text-[16px]">
              {t('From')} : {customerSourceData?.user || 'Unknown'}
            </div>
          </ConditionalRender>
          <div className="flex flex-wrap gap-3">
            {Object.entries(statusCounts).map(([status, count]) => {
              const dynamicStyle = StatusBackground(status);
              return (
                <div
                  key={status}
                  className={`rounded-[8px] font-inter-light px-2 py-1 outline-none text-[14px] md:text-[16px] text-white`}
                  style={dynamicStyle}
                >
                  {count as number} / {getProductsLength}
                </div>
              )
            })}

          </div>
        </div>
      </ConditionalRender >
      <ConditionalRender condition={currentStep === 1}>
        <div className="flex flex-col relative lg:flex-row gap-10  !md:min-w-auto md-max-w-[750px] lg:max-w-[1200px]">

          <div className="flex-none ">
            <div className="sticky top-0">
              <div className="w-full lg:w-[250px] rounded-[10px] border border-[#A2A1A833]">
                <div
                  onClick={() => {
                    setActiveTab(1);
                  }}
                  className={`px-6 py-4 rounded-t-[10px] flex gap-3 items-center ${activeTab === 1
                    ? `text-[#fff] bg-[--theme] font-inter-semibold`
                    : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                    }`}
                >
                  <Icon
                    iconType={IconType.PROFILE_ICON}
                    color={activeTab === 1 ? "#fff" : undefined}
                  />
                  <span className="whitespace-nowrap">
                    {t('Customer Information')}
                  </span>
                </div>
                <ConditionalRender condition={hasPermissiontoViewProducts}>
                  <div
                    onClick={() => {
                      setActiveTab(2);
                      refetchProducts();
                      refetchPartners();
                    }}
                    className={`px-6 py-4 flex gap-3 items-center ${activeTab === 2
                      ? `text-[#fff] bg-[--theme] font-inter-semibold`
                      : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                      }`}
                  >
                    <Icon
                      iconType={IconType.PRODUCTS_ICON}
                      color={activeTab === 2 ? "#fff" : undefined}
                    />

                    <span>{t('Products')}</span>
                  </div>
                </ConditionalRender>
                <ConditionalRender condition={hasPermissiontoViewDocuments}>
                  <div
                    onClick={() => {
                      setActiveTab(3);
                      refetchDocuments();
                    }}
                    className={`px-6 py-4 flex gap-3 items-center ${activeTab === 3
                      ? `text-[#fff] bg-[--theme] font-inter-semibold`
                      : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                      }`}
                  >
                    <Icon
                      iconType={IconType.DOCUMENT_ICON}
                      color={activeTab === 3 ? "#fff" : undefined}
                    />

                    <span>{t('Documents')}</span>
                  </div>
                </ConditionalRender>
                <ConditionalRender condition={data.quality !== null && hasPermissionToViewQuality}>
                  <div
                    onClick={() => {
                      setActiveTab(6);
                    }}
                    className={`px-6 py-4 flex gap-3 items-center ${activeTab === 6
                      ? `text-[#fff] bg-[--theme] font-inter-semibold`
                      : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                      }`}
                  >
                    <Icon
                      iconType={IconType.QUALITY_CHECK_ICON}
                      color={activeTab === 6 ? "#fff" : '#282D46'}
                    />

                    <span>{t('Quality Check')}</span>
                  </div>
                </ConditionalRender>
                <ConditionalRender condition={hasPermissiontoViewActivitylog}>
                  <div
                    onClick={() => {
                      setActiveTab(4);
                      refetchLogs();
                    }}
                    className={`px-6 py-4 rounded-b-[10px] flex gap-3 items-center ${activeTab === 4
                      ? `text-[#fff] bg-[--theme] font-inter-semibold`
                      : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                      }`}
                  >
                    <Icon
                      iconType={IconType.ACTIVITY_LOG_ICON}
                      color={activeTab === 4 ? "#fff" : undefined}
                    />

                    <span>{t('Activity Log')}</span>
                  </div>
                </ConditionalRender>
              </div>
              <ConditionalRender condition={data.art_of_application === 'Paper Application' && !data.has_submit_paper_application && hasPermissionToEditCostumer}>

                <div className="mt-10">
                  <button
                    className="bg-[#2CC95B] text-white rounded-[8px] px-4 py-2 lg:py-3 font-inter-semibold flex items-center gap-2 w-full justify-center"
                    onClick={() => setCurrentFormStep(9)}
                  >
                    <Icon
                      iconType={IconType.QUALITY_CHECK_ICON}
                      color="#fff"
                    />
                    {t('Submit Application')}
                  </button>
                </div>
              </ConditionalRender>
              <ConditionalRender condition={activeTab === 1 && hasPermissionToViewRelationship}>
                <div className="mt-5">
                  <h1 className="text-[#282D46] font-inter-bold">
                    {t('Related Customers')}
                  </h1>
                  <ErrorState error={isError}>{t('Something went wrong!')}</ErrorState>
                  {familyMemberData?.data?.map((item: Record<string, any>, index: number) => {
                    return (
                      <div
                        key={index}
                        className="bg-[--theme] h-[44px] rounded-[8px] flex items-center gap-[16px] mt-[18px] px-[10px]"
                      >
                        <Icon iconType={IconType.RELATED_CUSTOMER_ICON} />
                        <p className="font-inter-bold text-white text-[16px]">
                          {item.first_name} {item.last_name}
                        </p>
                      </div>
                    );
                  })}
                  <div>
                    <ConditionalRender condition={familyMemberData?.edit_relation !== false && hasPermissionToEditRelationship}>
                      <IconButton
                        className="!text-[--theme] bg-transparent border-none !p-0 !mt-[27px] sticky top-0"
                        secondary
                        onClick={() => {
                          setCurrentFormStep(8);
                        }}
                        icon={
                          <Icon
                            iconType={IconType.INCRASE_ICON}
                            color={themeColors.primary}
                          />
                        }
                      >
                        {t('Add new relation')}
                      </IconButton>
                    </ConditionalRender>
                    <div className="relative" onMouseLeave={onMouseLeave}>
                      <ConditionalRender
                        condition={familyMemberData?.edit_relation === false}
                      >
                        <Button onMouseEnter={onMouseEnter}>
                          <Icon
                            iconType={IconType.ALERT_ICON}
                            className="absolute right-[-10] bottom-[-10px]"
                            color={themeColors.primary}
                          />
                        </Button>
                        <Tooltip
                          isOpen={isHovered}
                          className="absolute right-0 w-[250px] h-auto bg-white p-[10px] rounded-[25px] shadow-custom  top-[30px] left-[10px] !z-[99999]"
                          content={
                            <Fragment>
                              <ul className="list-disc text-[14px]  ml-4 font-inter-regular">
                                <li>
                                  {t('Cannot update this customer relation as they are linked to an appointment.')}
                                </li>
                              </ul>
                            </Fragment>
                          }
                        />
                      </ConditionalRender>
                    </div>
                  </div>
                </div>
              </ConditionalRender>
            </div>
            <ConditionalRender condition={activeTab === 1}>
              <div className="flex flex-row gap-3 absolute right-0 top-[-45px] lg:top-0">
                {/* <div
                  className={`bg-[--theme] py-[6px] px-[10px] rounded-[5px] w-min`}
                >
                  <LocationIcon color="#fff" />
                </div> */}
                <div
                  className={`bg-[--theme] py-[6px] px-[10px] rounded-[5px] w-min cursor-pointer`}
                  onClick={() => setCurrentFormStep(6)}
                >
                  <EmailIcon color="#fff" />
                </div>
                <div
                  className={`bg-[--theme] py-[6px] px-[10px] rounded-[5px] w-min cursor-pointer`}
                  onClick={() => setCurrentFormStep(7)}
                >
                  <PhoneIcon color="#fff" />
                </div>
              </div>
            </ConditionalRender>
          </div>

          <div className="flex-1">
            <ConditionalRender condition={activeTab === 1}>
              <Form
                className="flex flex-col gap-5 mb-0"
                onSubmit={handleSubmit(onSubmit)}
              >
                {isCompany ? (
                  <InputsFolder title={t('General Company Information')}>
                    <div className="pb-2">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <Input
                          label={t('Company Name')}
                          placeholder={t('Company Name')}
                          {...register("company_name")}
                          error={errors?.company_name}
                        />
                        <Input
                          label={t('Legal Form')}
                          placeholder={t('Legal Form')}
                          {...register("legal_form")}
                          error={errors?.legal_form}
                        />
                        <Input
                          label={t('UID Number')}
                          placeholder={t('UID Number')}
                          {...register("uid_number")}
                          error={errors?.uid_number}
                          type="number"
                        />
                        <Input
                          label={t('Industry')}
                          placeholder={t('Industry')}
                          {...register("industry")}
                          error={errors?.industry}
                        />
                        <div>
                          <Label>{t('Number of Employees')}</Label>
                          <div className="w-full">
                            <Controller
                              control={control}
                              name="number_of_employees"
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <CounterControl
                                  isInput
                                  count={value}
                                  className="!mt-0"
                                  classes={{
                                    container: "w-full bg-white !border-inputborder",
                                  }}
                                  onChange={(value: number) => onChange(value)}
                                  onIncrement={() => onChange(value + 1)}
                                  onDecrement={() =>
                                    onChange(value >= 1 ? value - 1 : value)
                                  }
                                />
                              )}
                            />
                          </div>
                        </div>
                        <Input
                          label={t('Website')}
                          placeholder={t('Website')}
                          {...register("website")}
                          error={errors?.website}
                        />
                        <Input
                          placeholder={t('General Email')}
                          label={t('General Email')}
                          {...register("company_email")}
                          error={errors?.company_email}
                        />


                        <Input
                          placeholder={t('Enter phone number')}
                          {...register("company_phone_number")}
                          error={errors.company_phone_number}
                          name="company_phone_number"
                          label={t('Phone Number')}
                        />
                        <div className="relative">
                          <Label text={t('Preferred Language')} />
                          <Controller
                            name="prefered_language"
                            control={control}
                            rules={{ required: t("Language is required") }}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Choose language')}
                                options={languageData.map((language) => ({
                                  value: language.value,
                                  label: t(language.label),
                                }))}
                                value={
                                  field.value
                                    ? { value: field.value, label: t(languageData.find((lang) => lang.value === field.value)?.label as string) }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                              />
                            )}
                          />
                          {errors.prefered_language?.message && (
                            <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                              <>{t(errors.prefered_language?.message as string)}</>
                            </div>
                          )}
                        </div>
                        <Controller
                          control={control}
                          name="birthdate"
                          rules={{ required: t("Date of birth is required") }}
                          render={({ field: { onChange, value } }) => (
                            <PrimaryDatePicker
                              label={t('Date Of Founding')}
                              startDate={value}
                              {...register("birthdate")}
                              setStartDate={(date: string) => onChange(date)}
                            />
                        )}
                      />  
                      </div>
                      {/* <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
                                        {state.map((item: any) => {
                                          if (item?.data?.section === "Personal information") {
                                            extraFields[item?.data?.field_name] = {
                                              value: watch(item?.data?.field_name),
                                              default_text: item?.data?.default_text,
                                            };
                
                                            return (
                                              <Input
                                                label={item?.data?.field_name}
                                                type={item?.data?.field_type === "text" ? "text" : "number"}
                                                required={item?.data?.required}
                                                placeholder={item?.data?.default_text}
                                                {...register(item?.data?.field_name, { required: item?.data?.required ? t(`This field is required`) : false })}
                                                error={errors?.[item?.data?.field_name]}
                                              />
                                            );
                                          }
                                          return null;
                                        })}
                                      </div> */}

                    </div>

                  </InputsFolder>
                ) : null}
                <InputsFolder title={t(isCompany ? 'Primary Contact Person' : 'Personal information')}>
                  <div className="pb-2">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {isCompany ? (
                        <div className="relative">
                          <Label text={t('Salutation')} />
                          <Controller
                            name="salutation"
                            control={control}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Salutation')}
                                options={[
                                  { label: t('Mr.'), value: 'Mr.' },
                                  { label: t('Mrs.'), value: 'Mrs.' },
                                  { label: t('Ms.'), value: 'Ms.' },
                                  { label: t('Dr.'), value: 'Dr.' },
                                  { label: t('Other'), value: 'Other' },
                                ]}

                                value={
                                  field.value
                                    ? { value: field.value, label: t(field.value) }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(
                                  newValue: any,
                                  actionMeta: any
                                ) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}

                              />
                            )}
                          />
                          {errors.salutation?.message && (
                            <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                              <>{t(errors.salutation?.message as string)}</>
                            </div>
                          )}
                        </div>
                      ) : null}
                      <Input
                        label={t('First Name')}
                        placeholder={t('First Name')}
                        {...register("first_name")}
                        error={errors?.first_name}
                      />
                      <Input
                        label={t('Last Name')}
                        placeholder={t('Last Name')}
                        {...register("last_name")}
                        error={errors?.last_name}
                      />
                      {isCompany ? (
                        <Input
                          label={t('Job Title')}
                          placeholder={t('Job Title')}
                          {...register("job_title")}
                          error={errors?.job_title}
                        />
                      ): null}
                      <div className="relative">
                        <Label text={t('Nationality')} />
                        <Controller
                          name="nationality"
                          control={control}
                          render={({ field }) => (
                            <Creatable<any, false>
                              {...field}
                              placeholder={t('Nationality')}
                              options={nationalities.map(nationality => {
                                return {
                                  label: t(nationality), value: nationality
                                }
                              })}

                              value={
                                field.value
                                  ? { value: field.value, label: t(field.value) }
                                  : null
                              }
                              className="cursor-pointer font-inter-regular react-select-container"
                              classNamePrefix="react-select"
                              onChange={(
                                newValue: any,
                                actionMeta: any
                              ) => {
                                if (
                                  actionMeta.action === "select-option" &&
                                  newValue?.value
                                ) {
                                  field.onChange(newValue.value);
                                }
                              }}
                              styles={customStyles}
                              isValidNewOption={() => false}
                              menuPosition={"fixed"}
                              menuPortalTarget={document.body}

                            />
                          )}
                        />
                        {errors.nationality?.message && (
                          <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                            <>{t(errors.nationality?.message as string)}</>
                          </div>
                        )}
                      </div>
                      {!isCompany && (
                      <Controller
                        control={control}
                        name="birthdate"
                        rules={{ required: t("Date of birth is required") }}
                        render={({ field: { onChange, value } }) => (
                          <PrimaryDatePicker
                            label={t('Date Of Birth')}
                            startDate={value}
                            {...register("birthdate")}
                            setStartDate={(date: string) => onChange(date)}
                          />
                        )}
                      />  
                      )}
                      {!isCompany && (
                      <div className="relative">
                        <Label text={t('Language')} />
                        <Controller
                          name="language"
                          control={control}
                          rules={{ required: t("Language is required") }}
                          render={({ field }) => (
                            <Creatable<any, false>
                              {...field}
                              placeholder={t('Select...')}
                              options={
                                languageData?.map?.((language) => ({
                                  value: language.value,
                                  label: t(language.label),
                                })) || []
                              }
                              defaultValue={
                                data?.info?.language
                                  ? {
                                    value: data.info.language,
                                    label: t(data.info.language),
                                  }
                                  : null
                              }
                              defaultInputValue={data?.info?.language || ""}
                              value={
                                field.value
                                  ? { value: field.value, label: t(languageData.find((lang) => lang.value === field.value)?.label as string) }
                                  : null
                              }
                              className="cursor-pointer font-inter-regular react-select-container"
                              classNamePrefix="react-select"
                              onChange={(newValue: any, actionMeta: any) => {
                                if (
                                  actionMeta.action === "select-option" &&
                                  newValue?.value
                                ) {
                                  field.onChange(newValue.value);
                                } else if (actionMeta.action === "clear") {
                                  field.onChange("");
                                }
                              }}
                              styles={customStyles}
                              isValidNewOption={() => false}
                              menuPosition={"fixed"}
                              menuPortalTarget={document.body}
                            />
                          )}
                        />
                        {errors.language?.message && (
                          <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                            <>{t(errors.language?.message as string)}</>
                          </div>
                        )}
                      </div>
                      )}
                      <Input
                        placeholder={t('Enter phone number')}
                        {...register("phone")}
                        error={errors.phone}
                        name="phone"
                        label={t('Phone')}
                      />
                      <Input
                        placeholder={t('Enter email')}
                        label={t('Email')}
                        {...register("email")}
                      />
                    </div>
                    
                    <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {state.map((item: any) => {
                        if (item?.data?.section === "Personal information") {
                          extraFields[item?.data?.field_name] = {
                            value: watch(item?.data?.field_name),
                          };

                          return (
                            <Input
                              label={item?.data?.field_name}
                              type={
                                item?.data?.field_type === "text"
                                  ? "text"
                                  : "number"
                              }
                              placeholder={item?.data?.default_text}
                              required={item?.data?.required ? true : false}
                              {...register(item?.data?.field_name, {
                                required: item?.data?.required
                                  ? `${item?.data?.field_name} is required`
                                  : false,
                              })}
                              error={errors?.[item?.data?.field_name]}
                            />
                          );
                        }
                        else {
                          return null
                        }
                      })}
                      {data?.extra_fields?.map((field: any) => {
                        if (field.section === "Personal information") {
                          extraFields[field?.field_name] = {
                            value: watch(field?.field_name),
                          };
                          return (
                            <Input
                              label={field.field_name}
                              type={
                                field.field_type === "text" ? "text" : "number"
                              }
                              placeholder={field?.default_text}
                              required={field?.required ? true : false}
                              {...register(field.field_name, {
                                required: field.required
                                  ? `${field.field_name} is required`
                                  : false,
                                value: field?.field_value ?? "",
                              })}
                              error={errors?.[field.field_name]}
                            />
                          );
                        }
                        else {
                          return null
                        }
                      })}
                    </div>
                  </div>
                </InputsFolder>
                <InputsFolder title={t('Address details')}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
                      <div className="grid grid-cols-2 gap-5">
                        <Input
                          placeholder={t('Enter street')}
                          label={t('Street')}
                          icon={IconType.LOCATION_ICON}
                          {...register("address")}
                          error={errors?.address}
                          classes={{ icon: "!bg-white right-[8px]" }}

                        />
                        <Input
                          placeholder={t('Enter Nr')}
                          label={t('Nr')}
                          {...register("nr")}
                          error={errors?.nr}

                        />
                        <div className="col-span-2">
                          <Controller
                            name="postal_code"
                            control={control}
                            rules={{ required: `${t('Postal code is required')}` }}
                            render={({ field }) => (
                              <div>
                                <Label>
                                  {t('PLZ')}
                                </Label>
                                <AutoCompletInput
                                  suggestions={flatData}
                                  value={field.value}
                                  setValue={(name, value) => {
                                    setLocationValue(value);
                                  }}
                                  keepValue={true}
                                  className="block"
                                  clearErrors={() => { clearErrors('postal_code'); clearErrors('city') }}
                                  placeholder={t('Enter PLZ')}
                                  onChange={(e) => field.onChange(e.target.value)}
                                  icon={IconType.LOCATION_ICON}
                                  error={errors?.postal_code}
                                  name="postal_code"

                                />
                              </div>
                            )}
                          />
                        </div>
                        <div className="col-span-2">
                          <Input
                            placeholder={t('Enter City')}
                            label={t('City')}
                            {...register("city")}
                            error={errors?.city}

                          />
                        </div>
                      </div>
                      <div>
                        <iframe
                          className="border-inputborder border rounded-[8px]"
                          title="map"
                          src={`https://maps.google.com/maps?q='+${watch('postal_code')} ${watch('address')} ${watch('city')} ${watch('nr')}+'&t=&z=14&ie=UTF8&iwloc=&output=embed`}
                          style={{ width: "100%", height: "100%" }}
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>
                    </InputsFolder>
                <div className={
                  hasPermissionToAssignCustomers
                    ? "grid gap-5 lg:grid-cols-2 sm:grid-cols-1"
                    : "gap-5 lg:grid-cols-1 lg:gap-0"
                }
                >
                  <InputsFolder
                    title={t('Related details')}
                  >
                    <div>
                      <Label>{t('Note')}</Label>
                      <TextArea
                        {...register("note")}
                        rows={4}
                        className="resize-none border-[1px] border-inputborder rounded-[8px] w-full p-[7px] 2xl:p-[10px] outline-0 indent-2 placeholder-[#667085] font-inter-regular"
                        placeholder={t('Write note')}
                        error={errors?.note}
                      />
                      {state.map((item: any) => {
                        if (item?.data?.section === "Related details") {
                          extraFields[item?.data?.field_name] = {
                            value: watch(item?.data?.field_name),
                            default_text: item?.data?.default_text,
                          };
                          return (
                            <Input
                              label={item?.data?.field_name}
                              type={
                                item?.data?.field_type === "text"
                                  ? "text"
                                  : "number"
                              }
                              placeholder={item?.data?.default_text}

                              required={item?.data.required ? true : false}
                              {...register(item?.data?.field_name)}
                              error={errors?.[item?.data?.field_name]}
                            />
                          );
                        }
                        return null;
                      })}
                      {data?.extra_fields?.map((field: any) => {
                        if (field.section === "Related details") {
                          extraFields[field?.field_name] = {
                            value: watch(field?.field_name),
                          };
                          return (
                            <Input
                              label={field.field_name}
                              type={
                                field.field_type === "text" ? "text" : "number"
                              }
                              {...register(field.field_name, {
                                required: field.required
                                  ? `${field.field_name} is required`
                                  : false,
                                value: field?.field_value ?? "",
                              })}
                              placeholder={field?.default_text}

                              required={field?.required ? true : false}
                              error={errors?.[field.field_name]}
                            />
                          );
                        }
                        else {
                          return null
                        }
                      })}
                    </div>
                  </InputsFolder>
                  <ConditionalRender condition={hasPermissionToAssignCustomers}>
                    <InputsFolder
                      title={t('Assignement')}
                      childrenClassName="max-h-[180px] h-full rounded-l-none"
                    >
                      <div>
                        <div>
                          <Label>{t('Worker')}</Label>
                        </div>
                        <div>
                          <Controller
                            name="from_user_id"
                            control={control}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Choose Worker')}
                                options={fetchedUsers?.map?.((source: any) => ({
                                  label: `${source.name ?? ''} ${source.last_name ?? ''}`,
                                  value: source.id,
                                }))}
                                value={
                                  field?.value
                                    ? {
                                      value: field?.value,
                                      label:
                                        (
                                          fetchedUsers?.find?.(
                                            (item: any) =>
                                              item.id === field.value
                                          ) as { name: string } | undefined
                                        )?.name || field.value,
                                    }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                              />
                            )}
                          />
                        </div>
                        <div className="flex flex-col gap-[15px] 2xl:gap-[24px]"></div>
                      </div>
                    </InputsFolder>
                  </ConditionalRender>

                </div>
                <div className={`grid gap-5 lg:grid-cols-2 sm:grid-cols-1 mt-5`}>

                  {Object.entries(groupedFields).map(([section, fields]) =>
                    section !== "Personal information" &&
                      section !== "Contact information" &&
                      section !== "Address details" &&
                      section !== "Related details" ? (
                      <InputsFolder key={section} title={section}>
                        <div className="grid grid-cols-1 gap-5">
                          {fields.map((field) => (
                            <Input
                              key={field.field_name}
                              label={field.field_name}
                              placeholder={field?.default_text}
                              type={
                                field.field_type === "text" ? "text" : "number"
                              }
                              {...register(field.field_name, {
                                required: field.required
                                  ? `This field is required`
                                  : false,
                                value: field.field_value ?? "",
                              })}
                              error={errors?.[field.field_name]}
                            />
                          ))}
                        </div>
                      </InputsFolder>
                    ) : null
                  )}
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-end gap-4">
                  <ConditionalRender condition={usePermissions(['customers_pendings_create'])}>
                    <IconButton type="button" icon={<Icon iconType={IconType.NEW_TASK_ICON} />} onClick={() => { setIsTaskModalOpen(true) }}>
                      {t("Create Pending")}
                    </IconButton>
                  </ConditionalRender>
                  <ConditionalRender condition={usePermissions(['customers_view_edit'])}>
                    <Button
                      type="button"
                      onClick={() => {
                        setIsAddNewFieldModalOpen(true);
                      }}
                      className={`bg-transparent flex items-center gap-2 font-inter-medium text-[14px] text-[--theme]`}
                    >
                      <Icon
                        iconType={IconType.PLUS_ICON}
                        color={themeColors.primary}
                      />
                      {t('Add Field')}
                    </Button>
                    <IconButton className="sm:max-w-[138px]">
                      {updateLoading ? t("Updating...") : t("Update")}
                    </IconButton>
                  </ConditionalRender>
                </div>
              </Form>
            </ConditionalRender>
            <ConditionalRender condition={activeTab === 2}>
              <UpdateChooseProducts
                data={customerProducts ?? []}
                id={data.id}
                from_user_id={data.from_user_id}
                setFormStep={setCurrentFormStep}
                isLoading={isLoadingCustomerProducts}
                setFormDataOfProducts={setFormDataOfProducts}
                refetchProducts={refetchProducts}
                themeColors={themeColors}
              />
            </ConditionalRender>
            <ConditionalRender condition={activeTab === 3}>
              <UpdateCustomerDocuments
                onConfirm={onConfirm}
                customerData={data}
                themeColors={themeColors}
                currentStep={currentStep}
                data={customerDocumentsData}
                setCurrentFormStep={setCurrentFormStep}
                setFileLink={setFileLink}
                setHasDoucmentName={setHasDoucmentName}
                isLoadingGettingDocuments={isLoadingGettingDocuments}
              />
            </ConditionalRender>
            <ConditionalRender condition={activeTab === 4}>
              <ActivityLogItem
                data={
                  (activityLogData as { data?: any })
                    ?.data as ActivityLogData<any>
                }
                isLoading={isLoadingLogs}
                showReview={false}
                href="costumers"
              />
            </ConditionalRender>
            <ConditionalRender condition={activeTab === 6}>
              <ViewQualityCheck
                cusomterId={data.id}
              />
            </ConditionalRender>
          </div>
        </div>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 2}>
        <Form
          onSubmit={handleSubmitExtraField(onSubmitExtraFields)}
          className=""
        >
          {optionsByCheckbox.map(({ checkboxValue, customOptions, id }: any) => (
            <div key={id} className="flex items-center gap-4 mb-3">
              <div className="basis-1/3 flex items-center gap-4">
                <Checkbox
                  value={checkboxValue}
                  isChecked={
                    formDataOfProducts[id] &&
                      formDataOfProducts[id].checked
                      ? formDataOfProducts[id].checked
                      : false
                  }
                  onChange={(e) =>
                    handleCheckboxChange(id, e.target.checked)
                  }
                />
                <Label className="capitalize !mb-0">{t(checkboxValue)}</Label>
              </div>
              <div className="flex-1">
                <Controller
                  name="Company"
                  control={control}
                  render={({ field }) => (
                    <Creatable<any, false>
                      {...field}
                      options={customOptions}
                      value={field.value}
                      className="cursor-pointer font-inter-regular react-select-container"
                      classNamePrefix="react-select"
                      onChange={(selectedOption) => {
                        handleSelectChange(
                          id,
                          selectedOption ? selectedOption.value : null
                        )
                        setPartnerParams({
                          base_product: checkboxValue,
                          partner_id: optionsByCheckbox.filter(
                            (option: any) => option.checkboxValue === checkboxValue)[0]
                            ?.customOptions?.find((option: any) => option.value === selectedOption?.value
                            )?.id
                        })
                        setLastChangedSelectId(id);
                      }}
                      styles={customStyles}
                      placeholder={t('Choose Company')}
                      isValidNewOption={() => false}
                      menuPosition={"fixed"}
                      menuPortalTarget={document.body}
                      isDisabled={!formDataOfProducts[id]?.checked}
                    />
                  )}
                />
              </div>
              <div className="flex-1">

                <Controller
                  control={control}
                  name={`product.${id}`}
                  render={({ field }) => (
                    <Creatable<any, false>
                      {...field}
                      placeholder={t('Choose Product')}
                      options={PartnerProductsState[checkboxValue]?.map?.((product: any) => ({
                        label: product?.product,
                        value: product?.product,
                      }))}

                      value={
                        field.value
                          ? { value: field.value, label: field.value }
                          : null
                      }
                      isDisabled={isLoading}
                      className="cursor-pointer !w-full font-inter-regular react-select-container"
                      classNamePrefix="react-select !w-full"
                      onChange={(newValue: any, actionMeta: any) => {
                        if (actionMeta.action === "select-option" && newValue?.value) {
                          handleProductChange(id, newValue.value)
                          field.onChange(newValue.value);
                        }
                      }}
                      styles={customStyles}
                      isValidNewOption={() => false}
                      menuPosition={"fixed"}
                      menuPortalTarget={document.body}
                    />
                  )}
                />
              </div>
              {id < 7 ? (

                <div className="cursor-pointer w-[20px] flex justify-center flex-none" onClick={() => { addNewOption(checkboxValue) }}>
                  <Icon iconType={IconType.PLUS_ICON} color="#7D8592" />
                </div>
              ) : (
                <div className="cursor-pointer" onClick={() => { removeOption(id) }}>
                  <Icon iconType={IconType.DELETE_ICON} />
                </div>
              )}
            </div>
          ))}
          <IconButton
            type="submit"
            className="max-w-[138px] flex justify-end ml-auto mt-[30px] "
            disabled={isLoadingStoredProduct ? true : false}
          >
            {isLoadingStoredProduct ? t("Adding...") : t("Add Product")}
          </IconButton>
        </Form>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 3}>
        <Form
          onSubmit={handleSubmitUpload(onSubmitUploadDocument)}
          className="flex flex-col gap-[25px]"
        >
          <div className="relative">
            <Label text={t('File Section')} />
            <Controller
              name="file_section"
              control={controlUpload}
              rules={{ required: t("File Section is required") }}
              render={({ field }) => (
                <Creatable<any, false>
                  {...field}
                  placeholder={t('File Section')}
                  options={options.map((item) => ({
                    value: item.value,
                    label: t(item.label),
                  }))}
                  value={
                    field.value
                      ? { value: field.value, label: field.value }
                      : null
                  }
                  className="cursor-pointer font-inter-regular react-select-container"
                  classNamePrefix="react-select"
                  onChange={(newValue: any, actionMeta: any) => {
                    if (
                      actionMeta.action === "select-option" &&
                      newValue?.value
                    ) {
                      field.onChange(newValue.value);
                    }
                  }}
                  styles={customStyles}
                  isValidNewOption={() => false}
                  menuPosition={"fixed"}
                  menuPortalTarget={document.body}
                />
              )}
            />
            {uploadErrors.file_section?.message && (
              <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                {uploadErrors.file_section?.message as string}
              </div>
            )}
          </div>

          <Input
            placeholder={t('File Name')}
            label={t('File Name')}
            {...registerUpload("file_name")}
          />
          <Controller
            control={controlUpload}
            name="document"
            defaultValue={""}
            render={({ field: { onChange } }) => (
              <>
                <ConditionalRender condition={!fileName}>
                  <div className="text-[14px] font-inter-medium">
                    {t('Upload File')}
                  </div>
                  <div className={`flex justify-center relative`}>
                    <div className="flex items-center justify-center w-full">
                      <label
                        className={`flex flex-col-reverse cursor-pointer w-full h-[133px] border-[1px] rounded-[10px] border-border border-dashed bg-white relative`}
                      >
                        <div className="flex flex-col items-center justify-center">
                          <div className="bg-[--theme] w-[40px] absolute top-[20%] h-[40px] rounded-[10px] flex items-center justify-center">
                            <Icon iconType={IconType.UPLOAD_FILE_ICON} />
                          </div>
                          <div className="mb-3 text-center">
                            <p className="text-primaryTextColor text-[14px] font-inter-regular mb-1">
                              {t('Drag & Drop or')}{" "}
                              <span className={`text-[--theme] underline`}>
                                {t('choose file')}
                              </span>{" "}
                              {t('to upload')}
                            </p>
                            <p className="text-[#A2A1A8] text-[11px] font-inter-regular">
                              {t('Supported formats: pdf, doc, docx, csv. Maximum size: 10 MB')}
                            </p>
                          </div>
                        </div>
                        <Input
                          type="file"
                          onChange={(e) => {
                            if (e.target?.files) {
                              const file = e.target.files[0];
                              const fileUrl = URL.createObjectURL(file);
                              setUploadedFileUrl(fileUrl);
                              setUploadedFile(file as any);
                              setFileName(file.name);
                              onChange(file);
                              if (file) {
                                const size = file.size / 1024;
                                if (size < 1024) {
                                  setFileSize(`${size.toFixed(2)} KB`);
                                } else {
                                  setFileSize(`${(size / 1024).toFixed(2)} MB`);
                                }
                              }
                            }
                          }}
                          accept={".pdf"}
                          className="!z-[-11]"
                          classes={{ container: "!z-[-22]" }}
                        />
                      </label>
                    </div>
                  </div>
                </ConditionalRender>
                <ConditionalRender condition={fileName as any}>
                  <div className="mt-2  flex flex-col gap-[25px]">
                    <div className="text-[14px] font-inter-medium">
                      {t('Uploaded File')}
                    </div>
                    <div className="flex items-center justify-between cursor-pointer">
                      <div
                        onClick={() => {
                          setCurrentFormStep(4);
                          setViewFileUrl(uploadedFileUrl);
                        }}
                        className="flex items-center gap-5"
                      >
                        <Icon iconType={IconType.PDFUPLOAD_ICON} />
                        <div>
                          <h1 className="font-inter-medium text-[#282D46] text-[14px] capitalize">
                            {fileName ?? ""}
                          </h1>
                          <p className="uppercase text-[#6C737F] text-[14px] font-inter-regular">
                            {fileSize ?? ""}
                          </p>
                        </div>
                      </div>
                      <Button
                        onClick={() => {
                          onChange(null);
                          resetUpload();
                          setUploadedFile("");
                          setFileName("");
                        }}
                      >
                        <Icon iconType={IconType.DELETE_ICON} color="#7D8592" />
                      </Button>
                    </div>
                    <ErrorState error={hasErrorOnDocument}>
                      <span>
                        {" "}
                        {t('Something went wrong')},
                        <span className="underline">{t('please try again')}</span>{" "}
                      </span>
                    </ErrorState>
                  </div>
                </ConditionalRender>
              </>
            )}
          />
          <div className="flex justify-end gap-[26px] mt-5">
            <IconButton
              type="submit"
              icon={<Icon iconType={IconType.UPLOAD_FILE_ICON} />}
              disabled={isStoringLoadingDocument ? true : false}
            >
              {isStoringLoadingDocument ? t("Uploading...") : t("Upload")}
            </IconButton>
          </div>
        </Form>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 4}>
        {viewFileUrl && (
          <div style={{ height: "100%" }}>
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}
            >
              <Viewer
                fileUrl={viewFileUrl}
                renderLoader={() => (
                  <div className="min-h-[500px]">
                    <LoadingScreen />
                  </div>
                )}
              />
            </Worker>
            <>
              <Button
                onClick={() => setCurrentFormStep(3)}
                type="button"
                className="absolute top-[26px] sm:top-[31px] md:top-[45px] flex gap-4 font-inter-semibold text-[#282D46] text-[22px]"
              >
                <Icon
                  iconType={IconType.BACK_BUTTON_MODAL}
                  className="!w-[30px] !h-[30px]"
                  color={themeColors.primary}
                />
                {t('Application')}
              </Button>
              <div className="flex justify-end gap-[26px] mt-5">
                <IconButton
                  type="submit"
                  onClick={handleUploadClick}
                  disabled={
                    isStoringLoadingDocument || hasErrorOnDocument
                      ? true
                      : false
                  }
                  icon={<Icon iconType={IconType.UPLOAD_FILE_ICON} />}
                >
                  {t('Upload')}
                </IconButton>
              </div>
            </>
          </div>
        )}
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 5}>
        <div>
          <div
            ref={componentRef as RefObject<HTMLDivElement>}
            style={{ height: "100%" }}
          >
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}
            >
              <Viewer
                httpHeaders={{
                  Authorization: `Bearer ${token}`,
                }}
                renderLoader={() => (
                  <div className="min-h-[500px]">
                    <LoadingScreen />
                  </div>
                )}
                fileUrl={`${process.env.REACT_APP_API_URL}costumers/document/${fileLink}`}
              />
            </Worker>
          </div>
        </div>
        <>
          <Button
            onClick={() => setCurrentFormStep(1)}
            type="button"
            className="absolute top-[26px] sm:top-[31px] md:top-[45px] flex gap-4 font-inter-semibold text-[#282D46] text-[22px]"
          >
            <Icon
              iconType={IconType.BACK_BUTTON_MODAL}
              className="!w-[30px] !h-[30px]"
              color={themeColors.primary}
            />
            {t('Application')}
          </Button>
          <div className="flex justify-end gap-[26px] mt-5">
            <IconButton
              onClick={() => handlePrint()}
              type="button"
              secondary={true}
              icon={
                <Icon
                  iconType={IconType.PRINT_ICON}
                  color={themeColors.primary}
                />
              }
            >
              {t('Print')}
            </IconButton>
            <IconButton
              onClick={() => {
                fetch(
                  `${process.env.REACT_APP_API_URL}costumers/document/${fileLink}`
                )
                  .then((response) => response.blob())
                  .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    a.download = hasDocumentName ?? "";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                  })
                  .catch((error) => console.error(error));
              }}
              type="button"
              icon={<Icon iconType={IconType.DOWNLOAD_ICON} />}
            >
              {t('Download')}
            </IconButton>
          </div>
        </>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 6}>
        <SendEmailAppointment
          onConfirm={onConfirm}
          data={data}
          setCurrentFormStep={setCurrentFormStep}
          setIsUpdateModalOpen={setIsModalOpen}
        />
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 7}>
        <CallAppointment
          onConfirm={onConfirm}
          data={data}
          setCurrentFormStep={setCurrentFormStep}
          setIsUpdateModalOpen={setIsModalOpen}
        />
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 8}>
        <UpdateRelatedCustomerForm
          data={data}
          onAddCustomer={handleAddCustomer}
          setCurrentStep={setCurrentFormStep}
          releatedCustomerId={relatedCustomers}
        />
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 9}>
        <>
          <button
            type="button"
            className="absolute top-[26px] sm:top-[31px] md:top-[45px]"
            onClick={() => {
              setCurrentFormStep(1);
            }}
          >
            <Icon
              iconType={IconType.BACK_BUTTON_MODAL}
              color={themeColors.primary}
            />
          </button>
          <SubmitFiles
            id={data.id}
            setDocumentData={setDocumentData}
            setCurrentStep={setCurrentFormStep}
            setCheckedDocuments={setCheckedDocuments}
            CheckedDocuments={CheckedDocuments}
            onConfirm={onConfirm}
          />
        </>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 10}>
        <>
          <button
            type="button"
            className="absolute top-[26px] sm:top-[31px] md:top-[45px]"
            onClick={() => {
              setCurrentFormStep(9);
            }}
          >
            <Icon
              iconType={IconType.BACK_BUTTON_MODAL}
              color={themeColors.primary}
            />
          </button>
          <ViewPendingFile documentData={DocumentData} setCheckedDocuments={setCheckedDocuments} />
        </>
      </ConditionalRender>
      <CreateFollowUpTask
        hocisOpen={IsTaskModalOpen}
        hocToggleModal={() => { setIsTaskModalOpen(!IsTaskModalOpen) }}
        hocClasses={{
          modalClassName: "sm:max-w-[500px]"
        }}
        hocCurrentStep={1}
        hocTitle="Create Pending"
        closeModal={() => { setIsTaskModalOpen(false) }}
        customerId={data.id}
      />

      <AddNewField
        hocTitle="Create New Field"
        setExtraFields={setState}
        extraFields={state}
        hocisOpen={IsAddNewFieldModalOpen}
        hocToggleModal={() => setIsAddNewFieldModalOpen(false)}
        hocCurrentStep={1}
        hocClasses={{
          modalClassName: 'max-w-[500px] w-full'
        }}
      />
    </div >
  );
};

export default withModal(UpdateCustomerProcess);
